<template>
  <Overview />
</template>

<script>
  import Overview from './index';
  export default {
    name: 'customerContract',
    components: {
      Overview,
    },
  };
</script>
